import { Box, SxProps } from '@mui/material';

import { FC } from 'react';
import { LottiePlayer } from './lottie-player';
import MovieLoadingFile from '../../lotties/movieLoader.json';

export interface MovieLoaderWrapperProps {
  innerBox?: SxProps;
  outerBox?: SxProps;
}

export const MovieLoaderWrapper: FC<MovieLoaderWrapperProps> = ({
  innerBox,
  outerBox,
}) => {
  return (
    <Box sx={outerBox}>
      <LottiePlayer animationData={MovieLoadingFile} boxSx={innerBox} />
    </Box>
  );
};
